import Swiper from 'swiper';

const PostcardsSlider = () => {
    const init = () => {
        const carousels = document.querySelectorAll('.postcards__carousel');
        if (!carousels.length) return;

        const mq = window.matchMedia('(max-width: 739px)');

        carousels.forEach((carousel) => {
            let swiper = null;
            const slides = carousel.querySelectorAll('.swiper-slide');
            const desktopThreshold = parseInt(carousel.getAttribute('data-desktop-threshold') || '4', 10);
            const prevButton = carousel.querySelector('.swiper-pagination__button-prev');
            const nextButton = carousel.querySelector('.swiper-pagination__button-next');
            const pagination = carousel.querySelector('.postcards__pagination');
            const handlePrevClick = () => {
                if (swiper) {
                    swiper.slidePrev();
                }
            };
            const handleNextClick = () => {
                if (swiper) {
                    swiper.slideNext();
                }
            };

            const updateButtonStates = () => {
                if (!swiper || !prevButton || !nextButton) return;

                prevButton.disabled = swiper.isBeginning;
                nextButton.disabled = swiper.isEnd;

                prevButton.classList.toggle('swiper-button-disabled', swiper.isBeginning);
                nextButton.classList.toggle('swiper-button-disabled', swiper.isEnd);
            };

            const enable = () => {
                if (swiper) return;
                swiper = new Swiper(carousel, {
                    slidesPerView: 1,
                    spaceBetween: 24,
                    centeredSlides: false,
                    loop: false,
                    breakpoints: {
                        740: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: desktopThreshold,
                        }
                    }
                });

                if (prevButton && nextButton) {
                    prevButton.addEventListener('click', handlePrevClick);
                    nextButton.addEventListener('click', handleNextClick);
                    updateButtonStates();
                    swiper.on('slideChange', updateButtonStates);
                }

                if (pagination) {
                    pagination.hidden = false;
                }
            };

            const disable = () => {
                if (!swiper) return;
                swiper.destroy(true, true);
                swiper = null;

                if (pagination) {
                    pagination.hidden = true;
                }
            };

            const handleChange = () => {
                const shouldEnable = mq.matches ? slides.length > 1 : slides.length > desktopThreshold;

                if (shouldEnable) {
                    enable();
                } else {
                    disable();
                }
            };

            handleChange();

            if (mq.addEventListener) {
                mq.addEventListener('change', handleChange);
            } else {
                mq.addListener(handleChange);
            }
        });
    };

    return {
        init
    };
};

export default PostcardsSlider;
